import axios from "axios";
import { getApiConfig } from "../../apiConfig";
import { PatchTextCompanyService } from "../../textCompanyService";

export async function PatchCompany(company, modifiedBy, idCompany) {
  try {
    const apiConfig = await getApiConfig();
    const req = `${apiConfig.BASE_URL}company/${idCompany}`;
    const companyPatch = {
      modifiedBy: modifiedBy,
      name: company.name ? company.name : null,
      nifCif: company.nifCif ? company.nifCif : null,
      responsible: company.responsibleId ? company.responsibleId : null,
      functionsResponsible: company.functionResponsibleId ? company.functionResponsibleId : null,
      responsibleManagement : company.responsibleManagementId ? company.responsibleManagementId : null
      // privacyPolicy: company.text ? company.text : null,
    };

    const response = await axios.patch(req, companyPatch, apiConfig.HEADERS_CONFIG, {
    });
    if (company.image) {
      const req2 = `${apiConfig.BASE_URL}file/${response.data.image}`;

      const filePatch = {
        name: company.image.name,
        mimeType: company.image.mimeType,
        fileData: company.image.base64Content
      }

      await axios.patch(req2, filePatch, apiConfig.HEADERS_CONFIG, {

      });
    }

    for (const key in company) {

      // Verificar si la propiedad comienza con 'text', no es nula y su idioma no está en langTabs
      if (key.startsWith('text') && company[key]) {

        const response = await PatchTextCompanyService(company[key].text, company[key].textCompanyId);

      }
    }




    return response.data;
  } catch (error) {
    // Manejar el error
    throw error;
  }
}